export default "__VITE_PUBLIC_ASSET__543078b7__"